import { render, staticRenderFns } from "./MaterialsClient.vue?vue&type=template&id=3e653e85&"
import script from "./MaterialsClient.vue?vue&type=script&lang=js&"
export * from "./MaterialsClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports